import { render, staticRenderFns } from "./SettingIndex.vue?vue&type=template&id=57bdfcbb&"
import script from "./SettingIndex.vue?vue&type=script&lang=js&"
export * from "./SettingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports